import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useRef } from "react";
import { useQueryClient } from "react-query";
import { buildMeetingCostInfoSignature } from "utils/nextMeetingCard";
import { FirestoreDB } from "utils/firebase";

const useMeetingCostRefreshSubscription = (eventId, orgId) => {
  const queryClient = useQueryClient();
  const previousSignatureRef = useRef(null);

  useEffect(() => {
    previousSignatureRef.current = null;

    if (!eventId || !orgId) return undefined;

    const meetingRef = doc(FirestoreDB, "meetings", eventId);
    return onSnapshot(
      meetingRef,
      (snapshot) => {
        const signature = buildMeetingCostInfoSignature(snapshot.data(), orgId);
        const previousSignature = previousSignatureRef.current;

        previousSignatureRef.current = signature;

        if (!signature || signature === previousSignature) return;

        queryClient.invalidateQueries(["Cost", eventId]);
      },
      (error) => {
        console.error("Failed to subscribe to meeting cost updates", error);
      }
    );
  }, [eventId, orgId, queryClient]);
};

export default useMeetingCostRefreshSubscription;
